<template>
  <div class="YuliCard">
    <div class="info">
      <div class="icon">
        <img :src="img_url" v-if="img_url" />
      </div>
      <div class="token">#{{ token_id }}</div>
      <div class="level">Lv.{{ level }}</div>
      <img
        class="quality"
        :src="
          require(`@/assets/images/YuliApp/common/Yuli/type/${type_name}.png`)
        "
        v-if="type_name"
      />
      <img
        class="type"
        :src="
          require(`@/assets/images/YuliApp/common/Yuli/property/icon_${quality_name}.png`)
        "
        v-if="quality_name"
      />
    </div>

    <div class="benefit">
      <div class="benefit-title">Have Earned by Staking</div>
      <div class="benefit-list">
        <!-- Passcard -->
        <div :class="['benefit-item', 'benefit-item-passcard']">
          <img
            class="benefit-item-icon"
            :src="
              require('@/assets/images/YuliApp/YuliStaking/icon_passcard.png')
            "
          />
          <div class="benefit-item-text">
            {{ !isConsum && isRedeem ? 0 : passcard }}
          </div>
        </div>
        <!-- ART -->
        <div class="benefit-item">
          <img
            class="benefit-item-icon"
            :src="require('@/assets/images/YuliApp/YuliStaking/icon_art.png')"
          />
          <div class="benefit-item-text">
            {{
              `${!isConsum && isRedeem ? 0 : art == 0 ? 0 : tofixUtil(art, 2)}`
            }}
          </div>
        </div>
        <!--  EXP -->
        <div class="benefit-item">
          <img
            class="benefit-item-icon"
            :src="require('@/assets/images/YuliApp/YuliStaking/icon_exp.png')"
          />
          <div class="benefit-item-text">
            {{ !isConsum && isRedeem ? 0 : exp }}
          </div>
        </div>
      </div>
    </div>

    <div class="countdown">
      <div class="countdown-text">Staking Ends at</div>

      <div class="countdown-over" v-if="isStakingOver">Already Ended</div>

      <div class="countdown-item" v-if="!isStakingOver">
        <CountDown
          :end_at="end_at"
          @onCountDownEnd="handleCountDownEnd"
          @onDayChange="handleComputeIncome"
        />
      </div>
    </div>

    <div class="detail" @Click="handleToDetail">
      <div class="detail-text">
        {{
          !isStakingOver || (isStakingOver && isRedeem)
            ? "Details >"
            : "Claim your Yuli >"
        }}
      </div>
      <div class="detail-dot" v-if="isStakingOver && !isRedeem"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { onBeforeMount, onMounted, ref, getCurrentInstance } from "vue";
import appBridging from "@/utils/appBridging.js";
import store from "@/store";
import { getYOG2StakingRecord, getYuliList } from "@/api/staking.js";
import { TOAST_TYPE } from "@/components/Toast/index.vue";
import {
  PASSCARD_INCOME_MAP,
  ART_INCOME_MAP,
  YULI_QUALITY_TYPE_MAP,
  getPasscardIncomByDay,
} from "@/components/YuliStaking/constants/incomeMap.js";
import { getDiffDays } from "@/utils/date.js";
import { floatMul } from "@/utils/math.js";
import { tofix } from "@/utils/utils";
import {
  YULI_ROLE_TYPE_MAP,
  YULI_ROLE_PROPERTY_TYPE_MAP,
  TIME_TYPE,
} from "@/components/YuliStaking/constants/type.js";
import CountDown from "../CountDown";

export default {
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  components: {
    CountDown,
  },
  computed: {
    ...mapState({
      init: (state) => state.global.init,
      statusBarHeight: (state) => state.global.statusBarHeight,
      languageEnv: (state) => state.global.languageEnv,
      languagePackage: (state) => state.global.languagePackage,
    }),
  },
  watch: {
    languageEnv: {
      async handler(value) {
        if (value) {
          this.localesEnv = value;
        }
      },
      immediate: true,
      deep: true,
    },
    languagePackage: {
      async handler(value) {
        if (value) {
          this.localesPackage = value;
        }
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler(value) {
        this.yuliData = value;
        this.handleInit(value);
      },
      immediate: true,
      deep: true,
    },
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref("en");

    const yuliData = ref(null);

    const img_url = ref("");
    const token_id = ref("");
    const level = ref(0);
    const quality = ref("");
    const quality_name = ref("");
    const type = ref("");
    const type_name = ref("");

    const passcard = ref(0);
    const art = ref(0);
    const exp = ref(0);

    const end_at = ref(0);
    const isStakingOver = ref(false);
    const isCanClaimPasscard = ref(false);

    // 是否赎回
    const isRedeem = ref(false);

    // 是否付款
    const isConsum = ref(false);

    const tofixUtil = ref(tofix);

    /**
     * 处理倒计时结束
     */
    const handleCountDownEnd = () => {
      isStakingOver.value = true;
      // 重新计算收益
      handleComputeIncome();
      emit("onCountDownEnd");
    };

    /**
     * 处理跳转至详情
     */
    const handleToDetail = () => {
      emit("onDetail", yuliData.value);
    };

    /**
     * 处理收益
     */
    const handleComputeIncome = () => {
      const extension_attribute = yuliData.value?.extension_attribute;
      const role_type = extension_attribute?.role_type;
      const role_type_name = YULI_ROLE_PROPERTY_TYPE_MAP[role_type] || "";

      const extension = yuliData.value?.extension;
      const level = extension?.level;
      const start_time = extension?.start_time || 0;
      const end_time = extension?.end_time || 0;
      const days = extension?.days || 0;

      // 计划收益
      const _art_income_map = ART_INCOME_MAP[role_type_name] || {};
      const artPlan = _art_income_map[level] || 0; // 天为单位

      const _passcard_income_map = PASSCARD_INCOME_MAP[role_type_name] || {};
      const passcardPlan = _passcard_income_map[days] || 0;

      const expPlan = 375; // 默认375每天

      const end_at = end_time * 1000;
      const start_at = start_time * 1000;
      const nowaday = new Date().getTime();
      const _end_time = nowaday >= end_at ? end_at : nowaday;

      let _diff_days = getDiffDays(start_at, _end_time);
      // 服务数值返回不对的情况
      if (nowaday >= end_at && !_diff_days) {
        _diff_days = days;
      }
      const _passcard = getPasscardIncomByDay(role_type_name, days, _diff_days);
      const _art = floatMul(artPlan, _diff_days);
      const _exp = floatMul(expPlan, _diff_days);

      passcard.value = _passcard;
      art.value = _art;
      exp.value = _exp;
    };

    /**
     * 处理数据
     */
    const handleInit = (data) => {
      const _image = data?.image;
      const extension_attribute = data?.extension_attribute;
      const _token_id = data?.token_id || extension_attribute?.token_id;

      const role_type = extension_attribute?.role_type;
      const role_type_name = YULI_ROLE_PROPERTY_TYPE_MAP[role_type] || "";
      const role_property = extension_attribute?.role_property;
      const role_property_name = YULI_ROLE_TYPE_MAP[role_property] || "";

      // 收益
      handleComputeIncome();

      // 倒计时情况
      const extension = data?.extension;
      const _level = extension?.level;
      const end_time = extension?.end_time || 0;
      const _end_at = end_time * 1000;
      const nowaday = new Date().getTime();
      const _isStakingOver = nowaday > end_at;

      // 赎回情况
      const _redeem_at = extension?.redeem_at || "";
      const _is_redeem = data?.is_redeem || false;
      const _isRedeem = _redeem_at || _is_redeem;

      // 付款情况
      const _arg = Number(extension?.arg || "0");
      const _cost_arg = Number(extension?.cost_arg || "0");
      const _isConsum = Number(_cost_arg) > 0;

      // passcard领取情况
      // const _isCanClaimPasscard =
      //   extension?.passcard > 0
      //     ? extension?.passcard_at == 0 && extension?.passcard_tx_hash == ""
      //     : false;

      const _isCanClaimPasscard = true;

      img_url.value = _image;
      token_id.value = _token_id;
      level.value = _level;
      quality.value = role_property;
      quality_name.value = role_property_name;
      type.value = role_type;
      type_name.value = role_type_name;

      end_at.value = _end_at;
      isStakingOver.value = _isStakingOver;
      isCanClaimPasscard.value = _isCanClaimPasscard;
      isRedeem.value = _isRedeem;
      isConsum.value = _isConsum;
    };

    return {
      localesPackage,
      localesEnv,
      img_url,
      token_id,
      level,
      quality,
      type,
      passcard,
      art,
      exp,
      end_at,
      isStakingOver,
      isCanClaimPasscard,
      isRedeem,
      isConsum,
      handleCountDownEnd,
      handleToDetail,
      handleComputeIncome,
      handleInit,
      tofixUtil,
      type_name,
      quality_name,
      yuliData,
    };
  },
};
</script>

<style lang="less" scoped>
.YuliCard {
  width: 100%;
  height: 100%;
  font-family: "Inter";
  position: relative;
  background-image: linear-gradient(180deg, #12416c 0%, #1e779f 100%);
  border: 1.5px solid #00e0ff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  .info {
    width: 100%;
    height: 100%;

    .icon {
      width: 150px;
      height: 150px;
      position: absolute;
      top: 20px;
      left: 0px;
      right: 0px;
      margin: auto;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .token,
    .level {
      color: #83d3ff;
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
    }

    .token {
      position: absolute;
      top: 8px;
      left: 8px;
    }

    .level {
      position: absolute;
      top: 26px;
      left: 8px;
    }

    .quality,
    .type {
      width: 18px;
      height: 18px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }

    .quality {
      position: absolute;
      top: 8px;
      right: 32px;
    }

    .type {
      position: absolute;
      top: 8px;
      right: 8px;
    }
  }

  .benefit {
    position: absolute;
    left: 0px;
    right: 0px;
    top: 173px;

    &-title {
      color: #71bade;
      font-family: "Inter";
      font-size: 10px;
      font-style: normal;
      font-weight: 500;
      line-height: 12px;
      text-transform: uppercase;
      margin-left: 8px;
    }

    &-list {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      padding-left: 4px;
      margin-top: 8px;
    }

    &-item {
      margin-right: 2px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;

      &-icon {
        width: 16px;
        height: 16px;
      }

      &-text {
        color: #ffffff;
        font-size: 13px;
        font-weight: 500;
        line-height: 18px;
        margin-left: 0px;
        min-width: 45px;
      }

      &-passcard {
        .benefit-item-text {
          min-width: 18px;
        }
      }
    }
  }

  .countdown {
    width: 100%;
    border-top: 1px solid #1c6c99;
    position: absolute;
    top: 216px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 0px 8px;
    box-sizing: border-box;

    &-text {
      color: #71bade;
      font-size: 10px;
      font-weight: 500;
      line-height: 12px;
      text-transform: uppercase;
      margin-top: 7px;
      align-self: flex-start;
    }

    &-over {
      color: #ffa7a7;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      line-height: 14px;
      margin-top: 14px;
    }

    &-item {
      margin-top: 8px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
    }
  }

  .detail {
    position: absolute;
    bottom: 10px;
    width: 110px;
    height: 24px;
    border-radius: 1.61px;
    border: 0.81px solid #00ffe0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &-text {
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
      color: #00ffe0;
    }

    &-dot {
      position: absolute;
      right: -8px;
      top: -8px;
      width: 16px;
      height: 16px;
      background-image: url("~@/assets/images/YuliApp/YuliStaking/icon_dot.png");
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>
